// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logos-carousel{overflow:hidden;position:relative;width:100%;--_gap:10rem;margin-top:56px;margin-bottom:72px}.logos-carousel .logos-carousel-track{display:flex;grid-gap:var(--_gap);gap:var(--_gap);width:100%}.logos-carousel .logos-carousel-track img{max-width:unset;height:70px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
